@if (!isPasswordVisible) {
  <div
    [class.elevated]="isSecondStep && !isReferenceVisible && !editAccount && !addUnavailable"
    class="bp-modal mod-lg">
    @if (!isSmsPinVisible) {
      @if (!summary) {
        @if (currentStep; as header) {
          <bp-modal-header
            [step]="header.step"
            [title]="header.title"
            class="font-semibold">
            @if (header.left; as left) {
              <a
                (click)="onHeaderButtonClick(left)"
                (keydown.enter)="onHeaderButtonClick(left)"
                [tabIndex]="0"
                left>
                {{ left | translate }}
              </a>
            }
            @if (header.right; as right) {
              <a
                (click)="onHeaderButtonClick(right)"
                (keydown.enter)="onHeaderButtonClick(right)"
                [tabIndex]="0"
                right>
                {{ right | translate }}
              </a>
            }
          </bp-modal-header>
        }
        <!-- Modal BODY -->
        @if (!showLoadingSpinner()) {
          <div class="bp-modal-body">
            <div [ngClass]="{ 'pb-0': isFirstStep || isThirdStep }" class="bp-modal-body-section">
              <!-- Description -->
              @if (!addUnavailable) {
                <div
							[ngClass]="{
								'bp-modal-description': isFirstStep || isSecondStep,
								'text-center pb-20 text-summary-description': isThirdStep
							}">
                  @if (isFirstStep) {
                    {{ "which_wallet_do_you_want_to_withraw_from" | translate }}
                  }
                  @if (isSecondStep) {
                    @if (!isReferenceVisible) {
                      @if (sendEnabled) {
                        {{ "send_fiat_title_send_where" | translate }}
                      } @else {
                        @if (editAccount !== null) {
                          {{ "sepa_withdraw_description_creation" | translate }}
                        } @else {
                          {{ "sepa_withdraw_description_selection" | translate }}
                        }
                      }
                      <!-- #payments -->
                    } @else {
                      <!-- #payments -->
                      {{ "send_fiat_payment_ref_description" | translate }}
                    }
                  }
                  @if (isThirdStep) {
                    {{ how_much_money_key | translate }}
                  }
                </div>
              }
              <!--
              * First step - SELECT FIAT (eg: EUR, CHF, USD):
              -->
              @if (isFirstStep) {
                <div class="modal-grid mod-two-cols">
                  @for (fw of sendEnabled ? (getSendFiatWallets() | async) : wallets; track fw; let i = $index) {
                    <fiat-wallet-tile
                      (click)="selectWallet(fw)"
                      [active]="isWalletActive(fw)"
                      [ngClass]="'grid-item'"
                    [wallet]="fw"></fiat-wallet-tile>
                  }
                </div>
              }
              <!--
              * Second step - SELECT PAYOUT ACCOUNT (eg: Bank Transfer, Amazon, Skrill, Neteller):
              -->
              @if (isSecondStep && !isReferenceVisible) {
                @if (editAccount) {
                  <payout-account-detail
                    (cancelEvent)="cancelDetail()"
                    (finish)="createdAccount($event)"
                    (onChangeNameClick)="onChangeName()"
                    (onPasswordProtectError)="onPayoutAccountPasswordError()"
                    [account]="editAccount"
                    [ignoreTerms]="sendEnabled"
                    [logoPosition]="sendEnabled ? 'bottom' : 'top'"
                    [sendEnabled]="sendEnabled">
                    <!-- #payments -->
                  </payout-account-detail>
                } @else {
                  @if (providerStack) {
                    <div class="modal-grid mod-two-cols">
                      <!-- Show items list -->
                      @for (a of accountsForProviderObs(providerStack) | async; track a) {
                        <payout-tile
                          (createAccount)="createAccount($event)"
                          (deleteAccount)="deleteAccount($event)"
                          (editAccount)="selectEditAccount($event)"
                          (onClicked)="selectAccount(a)"
                          [account]="a"
                          [active]="isSame(a, account)"
                          [deleteAllowed]="sendEnabled || a.isCard()"
                          [ngClass]="'grid-item'">
                        </payout-tile>
                      }
                      <!-- Add new account -->
                      @if (isAddAllowed(providerStack)) {
                        <payout-add-tile
                          (clicked)="createAccount(providerStack)"
                        [ngClass]="'grid-item'"></payout-add-tile>
                      }
                    </div>
                  }
                }
                <!-- Step 2.2a - Inside selected provider stack (eg: When there are multiple Bank Transfer accounts and the provider click expands) -->
                <!-- Step 2.1 - Main list with all payout providers (eg: Bank Transfer, Amazon, Skrill, Neteller) -->
                <!-- Payments send flow will auto-click / select this step-->
                @if (showProviderList()) {
                  <div class="modal-grid mod-two-cols mod-in-modal">
                    @for (a of getAccountProviders(); track a; let i = $index) {
                      <!-- Bank Transfer Accounts -->
                      @if (isAccount(a)) {
                        <payout-tile
                          (createAccount)="createAccount($event)"
                          (deleteAccount)="deleteAccount($event)"
                          (editAccount)="selectEditAccount($event)"
                          (onClicked)="selectAccount(a)"
                          [account]="a"
                          [active]="isSame(a, account)"
                          [addAllowed]="canAddAccount(a)"
                          [deleteAllowed]="sendEnabled || a.isCard()"
                          [ngClass]="'grid-item'">
                        </payout-tile>
                      } @else {
                        <payout-tile
                          (click)="clickedProvider(a)"
                          [active]="isSamePayout(a, account)"
                          [currentFiat]="fiat"
                          [disabled]="!a?.hasFiat(fiat)"
                          [ngClass]="'grid-item'"
                          [provider]="a"
                          [stacks]="stacks(a)">
                        </payout-tile>
                      }
                      <!-- Payout providers like Amazon, Skrill, Neteller-->
                      <!-- Add tile #payments -->
                      @if (canAddPaymentAccount(a)) {
                        <payout-add-tile
                          (clicked)="createAccount(a)"
                        [ngClass]="'grid-item'"></payout-add-tile>
                      }
                    }
                  </div>
                  @if (getProvidersNotForFiat()?.length > 0) {
                    <hr class="mt-40 mb-30" />
                    <div class="modal-grid mod-two-cols mod-in-modal">
                      @for (a of getProvidersNotForFiat(); track a; let i = $index) {
                        <payout-tile
                          [currentFiat]="fiat"
                          [disabled]="!a?.hasFiat(fiat)"
                          [ngClass]="'grid-item'"
                          [provider]="a">
                        </payout-tile>
                      }
                    </div>
                  }
                  <p class="footnote">{{ "withdraw_working_on_new_options" | translate }}</p>
                }
                <!-- Step 2.2b - When user doesn't have any account for clicked provider, manual account creation is disabled, user can save his deposit details as details for payout account -->
                @if (addUnavailable) {
                  <app-withdraw-unavailable-modal
                    (makeDeposit)="switchToDeposit()"
                    [fiatName]="fiat.getName()"
                    [wallet]="wallet"
                    class="bp-modal-body-section mod-fullwidth">
                  </app-withdraw-unavailable-modal>
                }
              }
              <!--
              * Third step - select AMOUNT (3 button options top):
              -->
              @if (isThirdStep) {
                <div class="modal-grid mod-three-cols mod-in-modal mod-center">
                  @for (amount of amounts; track amount) {
                    <fiat-amount-tile
                      (click)="setAmount(amount)"
                      [amount]="amount"
                      [fiat]="fiat"
                      [ngClass]="'grid-item'">
                    </fiat-amount-tile>
                  }
                  @if (maxAmount > 0) {
                    <fiat-amount-tile
                      (click)="setAmount(maxAmount)"
                      [amount]="maxAmount"
                      [fiat]="fiat"
                      [max]="'max_amount_deposit' | translate"
                      [ngClass]="'grid-item'">
                    </fiat-amount-tile>
                  }
                </div>
              }
            </div>
            <!-- Still second Step 2.3 - Payments Send flow - Payment reference #payments -->
            @if (isSecondStep && isReferenceVisible) {
              <div class="bp-modal-body-section mod-fullwidth">
                <!-- Input -->
                <div class="contact-modal-form-fields pl-70 pr-70 pb-20">
                  <bp-input
                    (onKeyEnter)="onSavePaymentReference()"
                    (valueChange)="onPaymentReferenceChange($event)"
                    [(model)]="data.transaction"
                    [error]="data.transaction.getValidationError('payment_reference') | translate"
                    [label]="'send_fiat_payment_ref' | translate"
                    [maxlength]="35"
                    [placeholder]="'send_fiat_payment_ref_placeholder' | translate"
                    class="mod-ice-blue"
                    field="payment_reference"
                  type="text"></bp-input>
                  <!-- Valid reference syntax message -->
                  @if (!isReferenceValid) {
                    <div class="form-group has-error">
                      <div class="form-error mb-20">{{
                        "payment_reference_valid_syntax" | translate
                      }}</div>
                    </div>
                  }
                  <!-- Logo -->
                  <div>
                    <img
                      [alt]="'bitpanda_payments_logo_alt_text' | translate"
                      [src]="logoUrl(providerStack)"
                      class="payment-ref-logo" />
                  </div>
                </div>
                <!-- separator -->
                <hr class="mb-20 mt-30" />
                <!-- Save and continue Button-->
                <div class="pl-30 pr-30 mt-30 text-center">
                  <button
                    (click)="onSavePaymentReference()"
                    [disabled]="!validReference()"
                    class="btn btn-primary btn-lg btn-summary mod-amount"
                    type="button">
                    {{ "send_fiat_payment_action_button" | translate }}
                  </button>
                </div>
              </div>
            }
            <!--
            * Third step - select AMOUNT (input, calculations, goToSummary)
            -->
            @if (isThirdStep) {
              <div class="bp-modal-body-section mod-fullwidth pt-30">
                <div class="items-start flex-wrap modal-internal-transfer mod-input">
                  <bp-input
                    (onKeyEnter)="setSummary()"
                    (valueChange)="userWants()"
                    [(value)]="data.transaction._amount"
                    [formGroupClass]="false"
                    [iconUrlAltText]="'logo_alt_text' | translate"
                    [iconUrl]="fiat?.getLogo()"
                    [step]="getStepsFromOfferFiat()"
                    autofocus
                    class="mod-input-line"
                    iconLeading="true"
                    min="0"
                    name="amount_fiat"
                    required
                    type="fiat">
                    <!-- Payments send doesn't need this fees switcher #payments-->
                    @if (!sendEnabled && data?.transaction?.getFee() > 0) {
                      <a
                        (click)="switch()"
                        class="hover-pointer color-primary form-field-group-addon fiat-fees-toggle"
                        href="javascript:"
                        right>
                        {{
                        (data.transaction.areFeesIncluded
                        ? "inkl_fees_translation"
                        : "exkl_fees_translation"
                        ) | translate
                        }}
                      </a>
                    }
                  </bp-input>
                </div>
                <!-- labels: min amount + fees info -->
                <div
                  [ngClass]="{ 'flex-col': sendEnabled }"
                  class="bp-modal-row mt-10 bp-modal-custom-margin modal-internal-transfer mod-input">
                  <div class="bp-modal-column left">
                    @if (balance.operationalBalance < balance.balance) {
                      <div [class.error]="amountInvalidMax">
                        {{
                        "available_withdrawal_balance"
                        | translate
                        : [
                        balance.operationalBalance
                        | fiat_precision_symbol
                        : {
                        id: fiat?.getId(),
                        currencies: [fiat],
                        valueFirst: true
                      }
                      ]
                      }}
                      <span
                        [bp-tooltip]="'recent_deposit_disclaimer' | translate"
                        class="no-ul"
                        position="top">
                        <i class="bpi__icon-info-inverted"></i>
                      </span>
                    </div>
                  }
                  @if (minTransactionAmount() > 0) {
                    <div>
                      {{
                      min_amount_withdrawal_key
                      | translate
                      : [
                      minTransactionAmount()
                      | fiat_precision_symbol
                      : { id: fiat?.getId(), currencies: [fiat] }
                      ]
                      }}
                    </div>
                  }
                </div>
                @if (!sendEnabled) {
                  <div class="bp-modal-column right text-gray">
                    <span class="block">
                      {{ "you_get" | translate }}
                      <strong>{{
                        checkNegative(data.transaction.userGets)
                        | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
                      }}</strong>
                    </span>
                    <span class="block">
                      {{ "fees" | translate }}:
                      <strong>
                        {{
                        data?.transaction.getFee()
                        | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
                        }}
                      </strong>
                      <span
                        [bp-tooltip]="'tooltip_fees_fiat_deposit' | translate"
                        class="no-ul"
                        position="top">
                        <i class="bpi__icon-info color-primary"></i>
                      </span>
                    </span>
                  </div>
                } @else {
                  <div class="bp-modal-column text-gray mt-10">
                    <span class="block">
                      {{ "send_fiat_order_date" | translate }} {{ getCurrentDate() }}
                    </span>
                    <span class="block">{{ "send_fiat_free_fees" | translate }}</span>
                  </div>
                }
                <!-- Payments design for amount screen #payments-->
              </div>
              <!-- Cashplus park asset available info -->
              @if (checkIfParkAssetIsAvailable$ | async) {
                <div class="withdraw-cashplus-info">
                  <bp-info-box>
                    <div>
                      <span>{{ "cashplus_fiat_withdraw_infobox" | translate }} </span>
                      <a (click)="goToFiatWallet()">{{ "go-to-wallet" | translate }}</a>
                    </div>
                  </bp-info-box>
                </div>
              }
              <!-- Cashplus park asset available info -->
              <hr class="mb-20 mt-30" />
              <div class="pl-50 pr-50">
                <div [ngClass]="{ 'text-light': !isSufficient() }" class="bp-modal-row font-size-24">
                  <div class="bp-modal-column left mr-5">{{ "amount_total" | translate }}</div>
                  <div class="bp-modal-column right break">
                    <strong>{{
                      data.transaction.total
                      | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
                    }}</strong>
                  </div>
                </div>
                <div class="bp-modal-row font-size-15">
                  @if (data?.transaction.getFee() > 0) {
                    <div class="bp-modal-column left text-opaque">
                      {{ "inkl" | translate }}
                      {{
                      data?.transaction.getFee()
                      | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }
                      }}
                      {{ "fees" | translate }}
                    </div>
                  }
                  <div class="bp-modal-column right break"></div>
                </div>
              </div>
              <!-- Go To Summary button -->
              <div class="pl-30 pr-30 mt-20 text-center">
                <button
                  (click)="goToSummary()"
                  class="btn btn-primary btn-lg btn-summary mod-amount"
                  type="button">
                  {{ "goto_summary" | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="bp-modal-body loading">
          <loading-spinner></loading-spinner>
        </div>
      }
    }
    @if (summary) {
      <fiat-withdraw-summary
        (edit)="setEdit($event)"
        (finish)="save()"
        (onClose)="close()"
        [offer]="data.transaction"
        [sendEnabled]="sendEnabled"
        (payeeAction)="verifyPayeeAction()">
      </fiat-withdraw-summary>
    }
  } @else {
    @if (isSmsPinVisible) {
      <bp-modal-header [title]="'enter_your_sms_code' | translate" class="font-semibold">
        <a (click)="close()" (keydown.enter)="close()" [tabIndex]="0" right>{{ "close" | translate }}</a>
      </bp-modal-header>
      <div class="bp-modal-body">
        <div class="bp-modal-body-section">
          <payments-verify-sms-pin
            (accept)="onSmsPinSuccess($event)"
            (passwordLocked)="onSmsPinPasswordLocked()"
          [offer]="data.transaction"></payments-verify-sms-pin>
        </div>
      </div>
    }
  }
  <!-- Payments SMS PIN Confirmation #payments -->
</div>
} @else {
  @if (sendEnabled) {
    <password-validation (onClickBack)="close()" (onPasswordValidated)="onPasswordSuccess($event)">
    </password-validation>
  }
}
<!-- Payments Password #payments -->
